import { useState } from "react";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Stack,
  TextField,
  Typography,
} from "@mui/material";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import CheckIcon from "@mui/icons-material/Check";

interface Props {
  open: boolean;
  onClose: () => void;
  json: string;
}

export function UniverseJSONDialog({ open, onClose, json }: Props) {
  const [copied, setCopied] = useState(false);

  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(json);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    } catch {
      // fallback: select all text in the textarea
    }
  };

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="md"
      fullWidth
      aria-labelledby="universe-json-dialog-title"
      sx={{ "& .MuiDialog-paper": { bgcolor: "grey.100" } }}
    >
      <DialogTitle id="universe-json-dialog-title">
        Universe Export JSON
      </DialogTitle>
      <DialogContent>
        <Stack spacing={2}>
          <Typography variant="body2" color="text.secondary">
            Copy this JSON payload to use with the covered-wagon delivery
            system.
          </Typography>
          <TextField
            multiline
            rows={20}
            value={json}
            inputProps={{
              readOnly: true,
              style: { fontFamily: "monospace", fontSize: 12 },
              "data-testid": "universe-json-textarea",
            }}
            sx={{ "& .MuiInputBase-root": { bgcolor: "grey.200" } }}
            fullWidth
          />
        </Stack>
      </DialogContent>
      <DialogActions sx={{ px: 3, pb: 2 }}>
        <Button
          onClick={onClose}
          color="secondary"
          variant="outlined"
          data-testid="universe-json-close-btn"
        >
          Close
        </Button>
        <Button
          onClick={handleCopy}
          color="primary"
          variant="outlined"
          startIcon={copied ? <CheckIcon /> : <ContentCopyIcon />}
          data-testid="universe-json-copy-btn"
        >
          {copied ? "Copied!" : "Copy JSON"}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
